<template>
  <div class="reasult">
    <div class="search" @click="getSearch()">
      <img src="@/assets/img/search.png" alt="" />

      <div>{{ $route.query.keyWord }}</div>
    </div>
    <div class="list" v-if="!empty">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="item" v-for="(item, i) in list" :key="i">
          <img
            v-if="item.brandLogoMainUrl"
            :src="item.brandLogoMainUrl"
            alt=""
          />
          <img v-else src="@/assets/img/couponM.png" alt="" />
          <div class="mid">
            <div class="fir">{{ item.brandName }}</div>
            <div class="last" v-if="item.isShowSales === '1'">
              {{ item.brandSalesAmount || 0 }}·已售
            </div>
          </div>
          <div
            class="btn"
            @click="$router.push('/couponDetail?brandId=' + item.brandId)"
          >
            立即购买
          </div>
        </div>
      </van-list>
    </div>
    <div v-else>
      <div style="width:1.485rem;margin-top:.85rem;display:inline-block">
        <img src="@/assets/img/empty.png" style="width:100%" alt="" />
        <div
          style="font-size:.13rem;font-family: PingFangSC, PingFangSC-Regular;font-weight: 400;color: #999999;"
        >
          搜索不存在~
        </div>
      </div>
    </div>
    <!-- <van-popup
      class="find"
      position="left"
      style="height:100%;width:100%"
      v-model="searchShow"
    >
      <van-search
        v-if="searchShow"
        v-model="value"
        show-action
        placeholder="请输入搜索关键词"
        @search="onSearch"
        @cancel="onCancel"
    /></van-popup> -->
    <transition
      name="fade"
      @before-leave="changeallshow(false)"
      @after-enter="changeallshow(true)"
    >
      <div
        v-if="searchShow"
        style="height:100vh;width:100vw;background:#fff;position:absolute;top:0;left:0;z-index:9999999;"
        @touchstart="pullDown"
      >
        <van-search
          v-model="value"
          show-action
          placeholder="请输入搜索关键词"
          @search="onSearch"
          @cancel="onCancel"
        />
      </div>
    </transition>
  </div>
</template>
<script>
import { getSearchResults } from '@/api/floor'
export default {
  data() {
    return {
      searchShow: false,
      value: '',
      loading: false,
      finished: false,
      list: [],
      pageSize: 10,
      pageNum: 1,
      empty: false
    }
  },
  created() {},
  computed: {},
  methods: {
    pullDown() {
      this.$el.querySelector('.van-field__control').blur()
    },
    changeallshow(isState) {
      var bodyDoc = document.body
      if (isState) {
        this.topSpace = window.scrollY
        bodyDoc.style.position = 'fixed'
        bodyDoc.style.top = -this.topSpace + 'px'
      } else {
        bodyDoc.style.position = ''
        console.log(bodyDoc.style.position)
        bodyDoc.style.top = ''
        window.scrollTo(0, this.topSpace) // 回到原先位置
      }
    },
    // open() {
    //   this.$nextTick(() => {
    //     this.$el.querySelector('.van-field__control').focus()
    //   })
    // },
    onLoad() {
      this.loading = true
      this.finished = false
      this.getList()
    },
    getList() {
      getSearchResults({
        brandName: this.$route.query.keyWord,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }).then(res => {
        if (!res.data) {
          this.finished = true
          this.empty = this.list.length === 0
        } else {
          this.list.push(...res.data)
        }
        this.loading = false
        this.pageNum++
      })
    },
    getSearch() {
      this.value = this.$route.query.keyWord
      this.searchShow = true

      this.$nextTick(() => {
        this.$el.querySelector('.van-field__control').focus()
      })
    },
    onSearch(a) {
      if (!a.trim()) {
        this.value = a.trim()
        return
      }
      this.$router.replace('/searchReault?keyWord=' + a)
      this.list = []
      this.pageNum = 1
      this.empty = false
      this.onLoad()
      this.searchShow = false
    },
    onCancel() {
      this.searchShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
.fade-enter-active {
  transition: all 0.3s linear;
  transform: translateX(0);
}
.fade-leave-active {
  transition: all 0.3s linear;
  transform: translateX(200%);
  opacity: 0;
}
.fade-enter {
  transform: translateX(-100%);
  // opacity: 0;
}
.fade-leave {
  transform: translateX(0);
}
.fade-enter-to {
  // display: none;
  opacity: 0.8;
}
.find {
  ::v-deep .van-search {
    padding: 0.1rem 0.12rem;
    .van-search__content {
      padding-left: 0.12rem;
      border-radius: 0.14rem;
      .van-cell {
        padding: 0.05rem 0.08rem 0.05rem 0;
        .van-field__left-icon {
          margin-right: 0.04rem;
        }
      }
    }
    .van-search__action {
      padding: 0 0.08rem;
      font-size: 0.14rem;
      line-height: 0.34rem;
    }
  }
}
.list {
  .item {
    text-align: left;
    width: 3.45rem;
    height: 0.875rem;
    background: #ffffff;
    border-radius: 0.04rem;
    box-shadow: 0px 0.01rem 0.02rem 0px rgba(192, 192, 192, 0.08);
    padding-top: 0.1rem;
    padding-left: 0.1rem;
    box-sizing: border-box;
    position: relative;
    img {
      float: left;
      // width: 0.98rem;
      width: 0.675rem;
      height: 0.675rem;
      border-radius: 0.04rem;
      overflow: hidden;
      margin: 0 0.15rem;
    }
    .mid {
      float: left;
      margin-left: 0.14rem;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      height: 0.615rem;
      .fir {
        font-size: 0.15rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #333333;
        line-height: 0.21rem;
        width: 1.34rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .last {
        font-size: 0.13rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #666666;
        line-height: 0.185rem;
      }
    }
    .btn {
      position: absolute;
      top: 0.26rem;
      right: 0.1rem;
      width: 0.78rem;
      height: 0.295rem;
      // border: 0.01rem solid #dc863a;
      background-image: linear-gradient(53deg, #f46264 0%, #fb8606 100%);
      border-radius: 0.16rem;
      box-sizing: border-box;
      font-size: 0.13rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #fff;
      line-height: 0.295rem;
    }
  }
}
.reasult {
  padding: 0.1rem 0.15rem 0;
  box-sizing: border-box;
  .search {
    margin: 0 0 0.25rem;
    width: 3.45rem;
    height: 0.29rem;
    background: #ededed;
    border-radius: 0.14rem;
    display: flex;
    align-items: center;
    img {
      width: 0.13rem;
      height: 0.13rem;
      margin-left: 0.12rem;
      margin-right: 0.08rem;
    }
    div {
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #999999;
    }
  }
}
</style>
